import enforceObservableRules from './enforce-rules.js';
const fromEventEmitter = ({ emitter, event, get, set, defaultValue, getInitialized, }) => {
    const observe = (listener) => {
        emitter.on(event, listener);
        return () => emitter.removeListener(event, listener);
    };
    return enforceObservableRules({
        getInitialized,
        get,
        set,
        observe,
        defaultValue,
    });
};
export default fromEventEmitter;
